import { render, staticRenderFns } from "./lkuKoranJenisKiriman.vue?vue&type=template&id=d9fdbe80"
import script from "./lkuKoranJenisKiriman.vue?vue&type=script&lang=js"
export * from "./lkuKoranJenisKiriman.vue?vue&type=script&lang=js"
import style0 from "./lkuKoranJenisKiriman.vue?vue&type=style&index=0&id=d9fdbe80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports